/***
 * File name: details.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Notification Type tab in
 * the Personal Data Breach Notification Form
 *
 * This file defines all the input fields needed for the Notification Type tab
 *
 * Includes the ff:
 * - Tab number indicator
 * - Label of the form
 * - optionQuery indicates the query params for fetching additional data from the
 * backend side of the system
 * - children includes all the input fields in the form
 * - formActions indicate all the action buttons to be included on top of the form
 * - Other configurations for the form
 *
 */
export default function (vm) {
  const dateNow = new Date().toISOString().slice(0, 10)
  return {
    tab: 1,
    label: 'Notification Type',
    optionQuery: {
    },
    optionName: [],
    children: [
      {
        is: 'v-row',
        vShow: vm.operation !== 'view',
        vBind: {
          class: 'pt-2'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: '6'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'dbnNumber',
                vBind: {
                  label: 'DBN Number',
                  dense: true,
                  id: 'dbnNumber',
                  readonly: true,
                  disabled: true,
                  outlined: !vm.readOnly
                }
                // vOn: {
                //   input: () => { vm.$v.formItem.intro.$touch() },
                //   blur: () => { vm.$v.formItem.intro.$touch() }
                // }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'fullName',
                vBind: {
                  label: 'PIC',
                  dense: true,
                  id: 'PicName',
                  readonly: true,
                  disabled: true,
                  outlined: !vm.readOnly
                }
                // vOn: {
                //   input: () => { vm.$v.formItem.intro.$touch() },
                //   blur: () => { vm.$v.formItem.intro.$touch() }
                // }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'email',
                vBind: {
                  label: 'Email Address',
                  dense: true,
                  id: 'email',
                  readonly: true,
                  disabled: true,
                  outlined: !vm.readOnly
                }
                // vOn: {
                //   input: () => { vm.$v.formItem.intro.$touch() },
                //   blur: () => { vm.$v.formItem.intro.$touch() }
                // }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'representative',
                info: 'If not represented by a law firm, type the name of the organization.',
                vBind: {
                  class: 'required-field',
                  label: 'Representative',
                  dense: true,
                  id: 'representative',
                  disabled: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }]),
                  outlined: !vm.readOnly,
                  readonly: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }])
                }
                // vOn: {
                //   input: () => { vm.$v.formItem.intro.$touch() },
                //   blur: () => { vm.$v.formItem.intro.$touch() }
                // }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'contactInfo',
                info: 'Email of representative if there is any, if the same as PIC input the email of the PIC.',
                vBind: {
                  class: 'required-field',
                  label: 'Email Address',
                  dense: true,
                  id: 'contactInfo',
                  disabled: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }]),
                  outlined: !vm.readOnly,
                  readonly: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }])
                },
                vOn: {
                  input: () => { vm.$v.formItem.contactInfo.$touch() },
                  blur: () => { vm.$v.formItem.contactInfo.$touch() }
                }
              }
            ]
          }
        ]
      },
      // 3rd
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'DateComponent',
                formKey: 'dateOfOccurrence',
                vBind: {
                  value: vm.formItem.dateOfOccurrence,
                  label: 'Date of Occurence',
                  dense: true,
                  noTitle: false,
                  wholeMonth: true,
                  max: vm.formItem.dateOfDiscovery ? vm.formItem.dateOfDiscovery : `${dateNow}`,
                  id: 'dateOfOccurrence',
                  placeholder: '',
                  disabled: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }]),
                  readonly: true,
                  outlined: !vm.readOnly,
                  openPickerOnClick: true
                },
                vOn: {
                  input: () => { vm.$v.formItem.dateOfOccurrence.$touch() },
                  blur: () => { vm.$v.formItem.dateOfOccurrence.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'DateComponent',
                formKey: 'dateOfDiscovery',
                vBind: {
                  value: vm.formItem.dateOfDiscovery,
                  dateClass: 'required-field',
                  label: 'Date of Discovery',
                  dense: true,
                  noTitle: false,
                  wholeMonth: true,
                  max: `${dateNow}`,
                  id: 'dateOfDiscovery',
                  placeholder: '',
                  disabled: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }]),
                  readonly: true,
                  outlined: !vm.readOnly,
                  openPickerOnClick: true
                },
                vOn: {
                  input: () => { vm.$v.formItem.dateOfOccurrence.$touch() },
                  blur: () => { vm.$v.formItem.dateOfOccurrence.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'DateComponent',
                formKey: 'dateOfNotification',
                vBind: {
                  value: vm.status !== 'Drafted' && vm.status !== 'create' ? vm.formItem.dateOfNotification : '',
                  label: 'Date of Notification',
                  dense: true,
                  noTitle: false,
                  wholeMonth: true,
                  id: 'dateOfNotification',
                  placeholder: '---',
                  disabled: true,
                  outlined: !vm.readOnly
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        vShow: vm.status !== 'create' && vm.status !== 'Drafted',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 4
            },
            children: [
              {
                is: 'DateComponent',
                formKey: 'dateOfEvaluation',
                vBind: {
                  value: vm.formItem.dateOfEvaluation,
                  label: 'Date of Evaluation',
                  dense: true,
                  noTitle: false,
                  wholeMonth: true,
                  id: 'dateOfEvaluation',
                  disabled: true,
                  outlined: !vm.readOnly
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-textarea',
                formKey: 'briefSummary',
                vBind: {
                  value: vm.formItem.briefSummary,
                  label: 'Brief Summary',
                  class: 'cursor required-field',
                  readonly: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }]),
                  disabled: vm.readOnly || !vm.canUserEditField([{ userRole: 'pic', status: ['create', 'Drafted'] }]),
                  outlined: !vm.readOnly
                },
                vOn: {
                  input: () => { vm.$v.formItem.briefSummary.$touch() },
                  blur: () => { vm.$v.formItem.briefSummary.$touch() }
                }
              }
            ]
          }
        ]
      },
      // notification type header
      {
        is: 'v-row',
        vBind: {
          class: 'pt-8 pb-6'
        },
        children: [
          {
            is: 'v-col',
            children: [
              {
                is: 'LabelError',
                header: true,
                vText: 'Notification Type',
                vBind: {
                  errorMessage: 'Please select at least one (1) Notification type and validate all required fields.',
                  showError: vm.notifCheckbox,
                  bind: {
                    style: 'color: #162b54'
                  }
                }
              }
            ]
          }
        ]
      },
      {
        is: 'generateNotifications'
      }
    ],
    formActions: [],
    canEditNotifType:
    vm.readOnly ||
    !vm.canUserEditField([
      {
        userRole: 'pic',
        status: [
          'create',
          'Drafted'
        ]
      },
      {
        userRole: 'evaluator',
        status: [
          'For Evaluation',
          'For Evaluation - PBNEF',
          'For Evaluation - FBNER'
        ]
      },
      {
        userRole: 'reviewer',
        status: [
          'Initial Review',
          'Final Review',
          'Initial Review - PBNEF',
          'Final Review - PBNEF',
          'Initial Review - FBNER',
          'Final Review - FBNER'
        ]
      }
    ])
  }
}
